import { Fragment, type FC } from 'react';
import { wikiProse } from '../wikiTypography';

const NUMBER = /^#?\d+[»"”)]*[,.;:]?$/;

export type WikiNameMode = 'name' | 'text';

// WHY: название не должно рваться на «MAC-» / «10», «Case» / «2», «Galil» / «AR» и «Оружие |» / «Отделка» — склеиваем такие места при выводе, не меняя саму строку
// WHY: после типографа «|» приклеен к слову перед ним неразрывным пробелом («Керамбит⍽|») — такой токен тоже разделитель
const isBar = (token: string | undefined): boolean => token === '|' || (token?.endsWith(' |') ?? false);

export const wikiNameGroups = (name: string, mode: WikiNameMode = 'name'): string[] => {
  const tokens = name.split(' ').filter(Boolean);
  const bar = tokens.findIndex(isBar);
  const groups: string[] = [];
  tokens.forEach((token, i) => {
    const last = groups.length - 1;
    const weaponPart = mode === 'name' && bar > 0 && i <= bar + 1;
    const aroundBar = token === '|' || isBar(tokens[i - 1]);
    const glue = last >= 0 && (weaponPart || aroundBar || NUMBER.test(token));
    if (glue) groups[last] = `${groups[last]} ${token}`;
    else groups.push(token);
  });
  return groups;
};

export const WIKI_SLOT = '\u0001';

export const WikiPhrase: FC<{ text: string; value: string }> = ({ text, value }) => {
  const [before, after = ''] = text.split(WIKI_SLOT);
  return (
    <>
      {before}
      <span className="whitespace-nowrap">{value}</span>
      {after}
    </>
  );
};

// WHY: всё в одном span — внутри flex-контейнера (ссылки inline-flex) пробелы между отдельными узлами схлопывались («Кейс» + «eSports 2013»)
// WHY: типограф и здесь — короткие слова в названиях («Нож с лезвием-крюком») и в тексте ссылок не остаются в конце строки; повторный прогон уже обработанной строки ничего не меняет
export const WikiName: FC<{ name: string; mode?: WikiNameMode }> = ({ name, mode = 'name' }) => {
  const text = wikiProse(name);
  return (
    <span>
      {/^ /.test(text) && ' '}
      {wikiNameGroups(text, mode).map((group, i) => (
        <Fragment key={i}>
          {i > 0 && ' '}
          {/[\s-]/.test(group) ? <span className="whitespace-nowrap">{group}</span> : group}
        </Fragment>
      ))}
      {/[^ ] +$/.test(text) && ' '}
    </span>
  );
};
